import _slicedToArray from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState } from 'react';
export var useAccordions = function useAccordions() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    activeAccordion = _useState2[0],
    setActiveAccordion = _useState2[1];
  var toggle = function toggle(id) {
    setActiveAccordion(activeAccordion === id ? null : id);
  };
  return {
    activeAccordion: activeAccordion,
    toggle: toggle
  };
};